import { track } from '@ramp106/omrjs-tracking-reviews'
import type { EntityType } from '@ramp106/omrjs-tracking-reviews'

export interface PlanCtaPayload {
  entity_type: EntityType
  entity_id: string
  placement: string
}

// Migration window (M2 -> sunset M5 / REV-765): the fencing CTAs fire the canonical
// cta_click AND the deprecated Reviews plan_upgrade / plan_explore events.
export function trackPlanUpgrade(payload: PlanCtaPayload): void {
  track('cta_click', { category: 'meaningful_action', surface: 'cta', cta_id: 'plan_upgrade', cta_position: payload.placement })
  track('plan_upgrade', { surface: 'cta', ...payload })
}

export function trackPlanExplore(payload: PlanCtaPayload): void {
  track('cta_click', { category: 'engagement', surface: 'cta', cta_id: 'plan_explore', cta_position: payload.placement })
  track('plan_explore', { surface: 'cta', ...payload })
}
